<template>
  <div v-html="sanitize ? sanitizeHtml(content, sanitationOptions) : content"></div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: "",
    },
    sanitationOptions: {
      type: Object,
      default: () => {},
    },
    sanitize: {
      type: Boolean,
      default: true,
    }
  },
};
</script>
